import cx from 'classnames'
import { Icon } from '@/components/Icon'
import styles from './ContentError.module.css'
import { CenteredContent } from '@/components/CenteredContent'
import { Button } from '@/components/Button'
import { extractMessageFromError } from '@/utils/error-util'
import { match } from '@/utils/pattern-match-util'

interface ContentErrorProps {
  title?: string
  error: unknown
  /**
   * `section` is a compact variant for a card or pane, without the icon.
   */
  size?: 'base' | 'lg' | 'section'

  onRetry?(): unknown
}

/**
 * Shown in place of content that failed to load.
 */
export function ContentError({
  title,
  error,
  onRetry,
  size = 'base',
}: ContentErrorProps) {
  const isSection = size === 'section'
  return (
    <CenteredContent>
      <div
        className={cx(
          styles.contentError,
          match(size, {
            base: undefined,
            lg: styles.large,
            section: styles.section,
          }),
        )}
      >
        {!isSection && <Icon name="info" className={styles.bigIcon} />}
        <h3
          className={cx(
            styles.contentError,
            isSection ? styles.sectionTitle : styles.title,
          )}
        >
          {title || 'An error occured'}
        </h3>
        {error ? (
          <div
            className={cx(
              styles.contentError,
              isSection ? styles.sectionError : styles.error,
            )}
          >
            {extractMessageFromError(error)}
          </div>
        ) : null}
        {onRetry && (
          <div className={cx(styles.contentError, styles.retryContainer)}>
            <Button
              label="Retry"
              flat
              variant="destructive"
              onPress={onRetry}
            />
          </div>
        )}
      </div>
    </CenteredContent>
  )
}
